// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;
  background-color: #f8f8f8;
  gap: 30px;
}
.About-header {
  text-align: left;
  margin-left: 5%;
  margin-bottom: -60px;
  font-size: 2rem;
  font-weight: bold;
}
.img1 {
  margin-top: 40px;
  margin-left: 5px;
}
.img2 {
  margin-top: 5px;
  margin-left: 5px;
}
.img3 {
  margin-top: 5px;
  margin-right: 5px;
}
.img4 {
  margin-bottom: 5px;
  margin-left: 5px;
}

.page-images {
  flex: 25% 1;
  max-width: 25%;
  padding: 5cqw;
}

.page-images img {
  margin-top: 8px;
  vertical-align: middle;
  width: 100%;
}
.page-images {
  display: flex;
  justify-content: unset;
  flex-direction: row;
  gap: 20px;
  flex-basis: 50%;
  justify-content: center;
}
.page-images img {
  width: 100px;
  height: auto;
  border-radius: 5px;
  box-shadow: white;
}
.page-text {
  flex-basis: 50%;
  max-width: 500px;
  padding: 20px;
  text-align: left;
}

.learn-morebtn {
  background-color: #007e01;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 20%;
  bottom: 30%;
}

.page-text span {
  color: #10677a;
}

.page-text p {
  margin-top: -20px;
  font-size: 1rem;
  color: 000000;
}
.page-text h1 {
  font-size: 2rem !important;
  font-weight: bold;
  text-align: left;
  margin-top: -30px;
  background: linear-gradient(90deg, #75c02f, #10677a, #ff4400);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.learn-morebtn {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .column,
  .column1,
  .page-images,
  .page-text {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .page-section {
    padding: 90px 10px;
  }

  .page-text h1 {
    font-size: 1.5rem;
  }

  .page-text p {
    font-size: 0.9rem;
  }

  .page-images img {
    max-width: 80px;
  }
}

@media (min-width: 1024px) {
  .page-section {
    padding: 60px 30px;
  }

  .column,
  .column1,
  .page-images,
  .page-text {
    flex: 1 1 50%;
  }

  .page-text h1 {
    font-size: 2.5rem;
  }

  .page-images img {
    max-width: 150px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/About/About.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;IAIE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".page-section {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  padding: 50px 20px;\n  background-color: #f8f8f8;\n  gap: 30px;\n}\n.About-header {\n  text-align: left;\n  margin-left: 5%;\n  margin-bottom: -60px;\n  font-size: 2rem;\n  font-weight: bold;\n}\n.img1 {\n  margin-top: 40px;\n  margin-left: 5px;\n}\n.img2 {\n  margin-top: 5px;\n  margin-left: 5px;\n}\n.img3 {\n  margin-top: 5px;\n  margin-right: 5px;\n}\n.img4 {\n  margin-bottom: 5px;\n  margin-left: 5px;\n}\n\n.page-images {\n  flex: 25%;\n  max-width: 25%;\n  padding: 5cqw;\n}\n\n.page-images img {\n  margin-top: 8px;\n  vertical-align: middle;\n  width: 100%;\n}\n.page-images {\n  display: flex;\n  justify-content: unset;\n  flex-direction: row;\n  gap: 20px;\n  flex-basis: 50%;\n  justify-content: center;\n}\n.page-images img {\n  width: 100px;\n  height: auto;\n  border-radius: 5px;\n  box-shadow: white;\n}\n.page-text {\n  flex-basis: 50%;\n  max-width: 500px;\n  padding: 20px;\n  text-align: left;\n}\n\n.learn-morebtn {\n  background-color: #007e01;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  right: 20%;\n  bottom: 30%;\n}\n\n.page-text span {\n  color: #10677a;\n}\n\n.page-text p {\n  margin-top: -20px;\n  font-size: 1rem;\n  color: 000000;\n}\n.page-text h1 {\n  font-size: 2rem !important;\n  font-weight: bold;\n  text-align: left;\n  margin-top: -30px;\n  background: linear-gradient(90deg, #75c02f, #10677a, #ff4400);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.learn-morebtn {\n  margin-top: 10px;\n}\n\n@media (max-width: 768px) {\n  .column,\n  .column1,\n  .page-images,\n  .page-text {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n\n  .page-section {\n    padding: 90px 10px;\n  }\n\n  .page-text h1 {\n    font-size: 1.5rem;\n  }\n\n  .page-text p {\n    font-size: 0.9rem;\n  }\n\n  .page-images img {\n    max-width: 80px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .page-section {\n    padding: 60px 30px;\n  }\n\n  .column,\n  .column1,\n  .page-images,\n  .page-text {\n    flex: 1 1 50%;\n  }\n\n  .page-text h1 {\n    font-size: 2.5rem;\n  }\n\n  .page-images img {\n    max-width: 150px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
